import dynamic from 'next/dynamic'
import { useTranslation } from 'next-i18next/pages'

const NotoSansJpFont = dynamic(() =>
  import('components/CompanionFont/NotoSansJpFont').then(
    (module) => module.NotoSansJpFont
  )
)

const NotoSansKrFont = dynamic(() =>
  import('components/CompanionFont/NotoSansKrFont').then(
    (module) => module.NotoSansKrFont
  )
)

export const CompanionFont = () => {
  const { i18n } = useTranslation()

  switch (i18n.language) {
    case 'ja':
      return <NotoSansJpFont />
    case 'ko':
      return <NotoSansKrFont />
    default:
      return null
  }
}
